import React, { useEffect, useState } from 'react';

import { CircularProgress } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import ImageNotSupportedIcon from '@mui/icons-material/ImageNotSupported';
import axiosInstance from '../../app/axiosInstance';
import configUrls from '../../config/configUrls';
import { useOrgaoRoutes } from '../../config/useOrgaoRoutes';

interface ProtectedImageProps {
  filename: string;
  style?: React.CSSProperties; // Agora você pode passar um objeto CSS completo
  onImageLoaded?: (imageUrl: string) => void; // Função para passar a URL da imagem carregada
  hideImage?: boolean;
}
const ProtectedImage: React.FC<ProtectedImageProps> = ({ filename, style, onImageLoaded, hideImage = false }) => {
  const [imageUrl, setImageUrl] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<boolean>(false);
  const orgaoRoutes = useOrgaoRoutes();

  const API_URL = orgaoRoutes.ORGAO_API_EP;

  // Função para carregar a imagem de forma protegida
  const fetchImage = async (filename: string) => {
    try {
      setLoading(true);
      const response = await axiosInstance.get(`${API_URL}/anexo?filename=${filename}`, {
        responseType: 'blob' // Informamos que esperamos um Blob de imagem
      });

      const imageBlob = response.data; // Obtém o conteúdo da imagem
      const imageObjectUrl = URL.createObjectURL(imageBlob); // Cria uma URL temporária
      setImageUrl(imageObjectUrl); // Atualiza o estado com a URL da imagem
      onImageLoaded && onImageLoaded(imageObjectUrl); // Passa a URL gerada para o pai
    } catch (err) {
      console.error('Erro ao carregar a imagem:', err);
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (filename) {
      fetchImage(filename); // Faz a requisição da imagem assim que o componente for montado
    }
  }, [filename]);

  if (loading)
    return (
      <div>
        {' '}
        <CircularProgress size={24} />.
      </div>
    );

  if (error)
    return (
      <div>
        <ErrorOutlineIcon color="error" />
        <span>Erro ao carregar a imagem.</span>
      </div>
    );

  if (hideImage) return <div></div>;

  return imageUrl ? (
    <img
      src={imageUrl}
      alt="Imagem protegida"
      style={{ ...style }} // Aplica os estilos passados por props
    />
  ) : (
    <div>
      <ImageNotSupportedIcon />
    </div> // Caso a imagem não seja carregada
  );
};

export default ProtectedImage;
